/*
--------------------------------------------------------
    assets index /admin/assets/images
--------------------------------------------------------
*/
const bodyEditor = document.querySelector("body.usergroup-editor");
if (bodyEditor) {
    if (document.location.pathname.indexOf("/admin/assets") !== -1) {
        bodyEditor.classList.add("assets-index");

        const navItems = document.querySelectorAll("#sidebar a");
        for (const navLink of navItems) {
            navLink.addEventListener('click', function(event) {
                let target = event.target;
                if (event.srcElement.tagName === "SPAN") {
                    target = event.srcElement.parentNode;
                }

                if (typeof target.dataset.canEdit === "string" && target.dataset.canEdit.length) {
                    bodyEditor.classList.add("can-upload");
                } else {
                    bodyEditor.classList.remove("can-upload");
                }
          })
        }
    }
}

/*
--------------------------------------------------------
    assets upload /admin/assets/images
--------------------------------------------------------
*/

if (bodyEditor) {
    if (document.location.pathname.indexOf("/admin/entries/") !== -1) {
        setInterval(initModalListener, 3000);
    }
}


var init = false;
function initModalListener()
{
    var isAssetUpload = document.querySelector(".elementselectormodal .secondary-buttons input[name=assets-upload]");

    if (isAssetUpload && isAssetUpload.parentNode.offsetParent) {
        if (!init) {
            document.querySelector(".elementselectormodal").classList.add("locked");
            init = true;
            // console.log("init");
            const navItems = document.querySelectorAll(".elementselectormodal .sidebar a");

            for (const navLink of navItems) {
                navLink.addEventListener('click', function(event) {
                    let target = event.target;
                    if (event.srcElement.tagName === "SPAN") {
                        target = event.srcElement.parentNode;
                    }

                    if (typeof target.dataset.canEdit === "string" && target.dataset.canEdit.length) {
                        document.querySelector(".elementselectormodal").classList.remove("locked");
                    } else {
                        document.querySelector(".elementselectormodal").classList.add("locked");
                    }
                });
            }
        }

    }

}